<div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
        <div class="modal-header">
            <h1 class="modal-title" id="modalCoordonneesLabel">{{ isRecapitulatif ? titleRecapitulatif : titleAdministrateur }}</h1>
            <button (click)="modalRef.hide()" type="button" data-dismiss="modal" class="btn btn--close btn--icon-only">
                <svg class="svg-icon svg-close" aria-hidden="true" focusable="false"><use xlink:href="../../../assets/svg-icons/icon-sprite.svg#close"></use></svg>
                <span class="sr-only">Fermer : Coordonnées de contact</span>
            </button>
        </div>
        <div class="modal-body">
            <p>{{ isRecapitulatif ? texteRecapitulatif : texteAdministrateur }}</p>
            <p class="fz-16">Le symbole * indique les champs obligatoires</p>
            <form [formGroup]="popUpForm">
                <div class="form-group">
                    <label for="inputEmail">Email&nbsp;* (ex.: jean@gmail.com)</label>
                    <input
                        #emailInput
                        id="inputEmail"
                        class="form-control"
                        type="text"
                        formControlName="email"
                        [class.is-invalid]="popUpForm.get('email').invalid && popUpForm.get('email').dirty"
                    />
                    <div>
                        <span class="is-invalid">
                            <small *ngIf="popUpForm.get('email').errors?.pattern">{{ 'errors.invalidEmailPattern' | translate }}</small>
                            <small *ngIf="popUpForm.get('email').errors?.required">{{ 'errors.invalidEmailRequired' | translate }}</small>
                        </span>
                    </div>
                </div>
                <div class="form-group">
                    <label for="inputPhone">Téléphone</label>
                    <input
                        id="inputPhone"
                        type="text"
                        class="form-control"
                        formControlName="telephone"
                        [class.is-invalid]="popUpForm.get('telephone').invalid"
                    />
                    <div>
                        <span class="is-invalid">
                            <small *ngIf="popUpForm.get('telephone').invalid">
                                Numéro de téléphone non conforme. Formats valides:<br />
                                +33-111-222-333 +33111222333 0033111222333
                            </small>
                        </span>
                    </div>
                </div>
                <div class="btn-group">
                    <button id="button" type="button" (click)="annulerPopUp()" class="btn btn--ghost btn--default">
                        {{ isRecapitulatif ? texteButtonRecapitulatif : 'Annuler' }}
                    </button>
                    <button
                        class="btn btn--plain btn--primary"
                        type="submit"
                        [ngStyle]="{ width: isRecapitulatif ? '207px' : null }"
                        (click)="validerPopUp()">
                        Valider
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
